import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  containerForm: {
    maxWidth: 430,
    minWidth: 320,
    padding: theme.spacing(5),
    [theme.breakpoints.down('xs')]: {
      padding: '40px 20px',
    },
  },
  title: {
    color: theme.screens.redefinirSenha.title,
    fontFamily: 'BancoDoBrasilTitulos',
    fontSize: '24px',
    lineHeight: '32px',
    paddingBottom: '8px',
    fontWeight: 500,
  },
  text: {
    color: '#4C4C4C',
    fontFamily: 'Inter',
    fontSize: '14px',
    maxWidth: '300px',
    textAlign: 'left',
    paddingBottom: '32px',
    fontWeight: 300,
  },
  cadastroImg: {
    width: '82px',
    height: '82px',
    paddingBottom: '16px',
  },
  fieldsGrid: {
    maxWidth: '100%',
  },
  fields: {
    paddingBottom: 24,
  },
  iconeVisibility: {
    color: theme.screens.redefinirSenha.iconeVisibility,
  },
  information: {
    padding: '0 2px',
    color: theme.appColors.newGrey,
    fontFamily: 'BancoDoBrasilTextos',
    lineHeight: '26px',
    fontWeight: '400',
    fontSize: 14,
    letterSpacing: -0.58,
    '& > span': {
      fontWeight: 700,
    },
    marginBottom: 15,
  },
  informationItem: {
    display: 'flex',
    '& > div': {
      paddingInline: '8px',
    },
  },
  button: {
    color: '#FFFFFF',
    fontFamily: 'BancoDoBrasilTitulos',
    fontSize: 14,
    lineHeight: '20px',
    letterSpacing: '0.66px',
    textAlign: 'center',
    marginTop: theme.spacing(1),
    width: '180px',
    height: '48px',
    [theme.breakpoints.down('xs')]: {
      width: '90vw',
    },
  },
  link: {
    color: theme.screens.redefinirSenha.link,
    fontSize: '14px',
    fontWeight: '700',
    letterSpacing: '-0.53px',
  },
}));
